import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        domain: {
            domainName: window.location.hostname == "localhost" ? "" : "",
            domainNameWithHttp: window.location.hostname == "localhost" ? 'http://localhost:55475/' : 'https://www.ausa.com.mx',
            domainNameForApi: window.location.hostname == "localhost" ? 'http://localhost:55475/api/' : 'https://www.ausa.com.mx/api/',
            domainAusa: window.location.hostname == "localhost" ? 'http://localhost:55475/' : 'https://www.ausa.com.mx/'
        },
    },
  mutations: {},
  actions: {},
  modules: {}
});
